import React, { Component } from 'react';
import { Button, Table, Jumbotron, Container, Row, Col, OverlayTrigger, Tooltip, Form } from 'react-bootstrap';
import Auth from '../../../middleware/auth';
import funciones from '../../../middleware/funciones';
// ;
import config from '../../../config';
import { saveAs } from 'file-saver';
import Spinner from '../../subcomponent/spinner';
import ModalConfirm from '../../subcomponent/modalConfirm';
import BackButton from '../../widgets/back_button';


class Gestiones extends Component {
  constructor(props) {
    super(props);
    const currentCompany = sessionStorage.getItem('company');
    const currentUserType = sessionStorage.getItem('tipo');
    const state = Auth.isAuthenticated();
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
    const yyyy = today.getFullYear();
    const todayFormat = yyyy + "-" + mm + "-" + dd;

    this.state = {
      documentos: [],
      docPendientes: [],
      docProceso: [],
      docToSend: [],
      resoluciones: [],
      empresa: currentCompany,
      tipo: currentUserType,
      isLogin: state,
      tipo_documento: "",
      numero_inicial: "",
      numero_final: "",
      searchTipo: "",
      searchNumero: "",
      searchCliente: "",
      fecha_inicial: todayFormat,
      fecha_final: todayFormat,
      loading: false,
      visObsPDF: false,
      listAllPDF: 0,
      buttonPres: 0,
      id_ped: ""
    };
  }

  componentDidMount() {
    const { empresa } = this.state
    const { tipo } = this.state
    const datasend = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'empresa': empresa,
        'tipo': tipo,
      }
    };
    fetch(config.servBackEnd + '/resoluciones/', datasend)
      .then(res => res.json())
      .then((data) => {
        const tmpTipo = [];
        data.forEach(element => {
          if (element.TIPO_DOCUMENTO === "PE") tmpTipo.push(element);
        });
        this.setState({ resoluciones: tmpTipo });
      })
      .catch((error) => console.error(error))
  };

  updateInfo = () => {
    this.setState({ loading: true });
    const { empresa } = this.state
    const { tipo } = this.state
    const busqueda = {
      fecha_ini: this.state.fecha_inicial,
      fecha_fin: this.state.fecha_final,
      numero_inicial: this.state.numero_inicial,
      numero_final: this.state.numero_final,
      tipo_doc: this.state.tipo_documento
    };

    const datasend = {
      method: 'POST',
      body: JSON.stringify(busqueda),
      headers: {
        'Content-Type': 'application/json',
        'empresa': empresa,
        'tipo': tipo,
      }
    };
    fetch(config.servBackEnd + '/documents/currentorders', datasend)
      .then(res => res.json())
      .then((data) => {
        if (data.ok) {
          const datos = data.data;
          this.setState({ documentos: datos, loading: false });
        } else {
          if (data.code === "0000") this.setState({ documentos: [], loading: false });
        }
      })
      .catch((error) => console.error(error))
  }

  buscar = ({ target }) => {
    const { name, value } = target;
    this.setState({ [name]: value });
  };

  getPDF = ({ target }, data) => {
    target.disabled = true;
    const { empresa } = this.state;

    const id = data.ID_PEDIDOS;
    const tipo = data.TIPO_DOCUMENTO_CABECERA;
    const numero = data.NUMERO_FACTURA_CABECERA;

    const nombreArchivo = tipo + '-' + numero + '.pdf';

    const datasend = {
      method: 'GET',
      headers: {
        'Content-Type': 'blob',
        'empresa': empresa,
        'hist': '3'
      }
    }
    fetch(config.servBackEnd + '/files/getpdfpedido/' + id, datasend)
      .then((res) => {
        if (res.ok) return res.blob();
      })
      .then((blob) => {
        if (blob) {
          const file = new Blob([blob], { type: 'application/pdf' });
          saveAs(file, nombreArchivo);
        } else {
          //console.log("Archivo Inexistente");
        }
        target.disabled = false;
      })
      .catch((err) => {
        console.error(err);
        target.disabled = false;
      })
  };

  eliminarPedido = ({ target }, data) => {
    this.setState({ id_ped: data.ID_PEDIDOS })
    this.setState({ buttonPres: 2 });
    this.setState({ show: true });
    //console.log(this.state.buttonPres)
  }

  enviarInfo = () => {
    let ruta = "";
    const { id_ped } = this.state;
    //console.log(id_ped)
    this.setState({ show: false });
    const { empresa } = this.state;

    const datasend = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'empresa': empresa,
      }
    }
    ruta = config.servBackEnd + '/invoice/deleteinvoice/' + id_ped;
    fetch(ruta, datasend)
      .then(response => response.json())
      .then(data => {
        if (data.ok) {
          alert("Tarea finalizada correctamente");
          this.updateInfo();
        } else {
          alert("No se pudo completar la actividad")
        }
      })
  }

  handleClose = () => {
    this.setState({ show: false });
  };

  render() {
    //variables
    const mensajeConfirm = '¿Esta seguro que desea eliminar el pedido?';
    const facturas = this.state.documentos;
    const validacionUser = this.state.isLogin;
    const { searchTipo } = this.state;
    const { searchNumero } = this.state;
    const { searchCliente } = this.state;
    const { loading } = this.state;
    const { resoluciones } = this.state;
    const { tipo, empresa } = this.state
    const inactiveOptions = !(tipo === '3' && empresa === '900130488')
    //funciones
    const updateInfo = this.updateInfo;
    const getPDF = this.getPDF;
    const eliminarPedido = this.eliminarPedido;
    return (
      <div className="Menu">

        <div>
          <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm} ></ModalConfirm>
        </div>
        <Jumbotron className="Jumbotron">
          <h2>Reporte de pedidos</h2>
        </Jumbotron>
        <BackButton />
        {!validacionUser && <p>La sesion se ha cerrado por favor ingrese de nuevo</p>}
        {validacionUser &&
          <div>
            <Container fluid>
              <Row className="justify-content-md-center" >
                <Col className="mb-2" xs={5} lg={1}>FECHA INICIO</Col>
                <Col className="mb-2" xs={7} lg={2}>
                  <Form.Control type="date" onChange={e => this.setState({ fecha_inicial: e.target.value })} value={funciones.formatDate(this.state.fecha_inicial)} />
                </Col>
                <Col className="mb-2" xs={5} lg={1}>FECHA FIN</Col>
                <Col className="mb-2" xs={7} lg={2}>
                  <Form.Control type="date" onChange={e => this.setState({ fecha_final: e.target.value })} value={funciones.formatDate(this.state.fecha_final)} />
                </Col>
                <Col className="mb-2" xs={5} lg={1}>TIPO</Col>
                <Col className="mb-2" xs={7} lg={1}>
                  <Form.Control as="select" onChange={e => this.setState({ tipo_documento: e.target.value })} value={this.state.tipo_documento} >
                    <option value=""></option>
                    {
                      resoluciones.map((resoluion, i) => {
                        return <option key={'td' + i} value={resoluion.PREFIJO}>{resoluion.PREFIJO}</option>;
                      })
                    }
                  </Form.Control>
                </Col>
                <Col className="mb-2" xs={5} lg={1}>NUMERO INICIAL</Col>
                <Col className="mb-2" xs={7} lg={1}>
                  <Form.Control type="number" onChange={e => this.setState({ numero_inicial: e.target.value })} value={this.state.numero_inicial} />
                </Col>
                <Col className="mb-2" xs={5} lg={1}>NUMERO FINAL</Col>
                <Col className="mb-2" xs={7} lg={1}>
                  <Form.Control type="number" onChange={e => this.setState({ numero_final: e.target.value })} value={this.state.numero_final} />
                </Col>
                <Col className="mb-2" xs={12} lg={2}>
                  <Button id="actualizar" name="actualizar" onClick={updateInfo}  >Consultar Pedidos</Button>
                </Col>
              </Row>
              <Row>
                <Table hover bordered responsive size="sm" className="table">
                  <thead>
                    <tr>
                      <th><input type="text" maxLength="2" size="3" name="searchTipo" onChange={this.buscar} /></th>
                      <th><input type="text" maxLength="10" size="11" name="searchNumero" onChange={this.buscar} /></th>
                      <th><input type="text" maxLength="10" size="11" name="searchCliente" onChange={this.buscar} /></th>
                    </tr>
                    <tr>
                      <th>Tipo Documento</th>
                      <th>Numero Documento</th>
                      <th>Nombre Cliente</th>
                      <th>Fecha Pedido</th>
                      <th>Estado</th>
                      <th colSpan="4">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(!loading && facturas.length > 0) &&
                      facturas.map(function (currentData, index) {
                        if (currentData.TIPO_DOCUMENTO_CABECERA.toLowerCase().search(searchTipo.toLowerCase()) > -1
                          && currentData.NUMERO_FACTURA_CABECERA.toLowerCase().search(searchNumero.toLowerCase()) > -1
                          && currentData.NOMBRE_CLIENTE.toLowerCase().search(searchCliente.toLowerCase()) > -1
                        ) {
                          return <tr name={index} key={index + "d0"}>
                            <td name="tipo" >{currentData.TIPO_DOCUMENTO_CABECERA}</td>
                            <td name="numero" >{currentData.NUMERO_FACTURA_CABECERA}</td>
                            <td name="cliente" >{currentData.NOMBRE_CLIENTE}</td>
                            <td>{funciones.formatDate(currentData.FECHA_DOCUMENTO)}</td>
                            <td>{funciones.estadosPedidos(currentData.ESTADO_PEDIDO)}</td>
                            {inactiveOptions && <td><Button disabled={!(currentData.ESTADO_PEDIDO.toString() === '0' || currentData.ESTADO_PEDIDO.toString() === '7')} href={"/editpedidos/?" + currentData.ID_PEDIDOS}>Editar</Button></td>}
                            {inactiveOptions && <td><Button variant="danger" disabled={currentData.ESTADO_PEDIDO.toString() === '1' || currentData.ESTADO_PEDIDO.toString() === '2'} onClick={(e) => eliminarPedido(e, currentData)}>Eliminar</Button></td>}
                            <OverlayTrigger placement='top-start' overlay={<Tooltip>Descargar Representacion Grafica</Tooltip>}>
                              <td ><Button className="buttonP" onClick={(e) => getPDF(e, currentData)} variant="outline-primary"></Button></td>
                            </OverlayTrigger>

                            <td name="id" className="d-none" >{currentData.ID_FACTURA}</td>
                          </tr>;
                        } else {
                          return <tr key={index + "f0"}></tr>
                        }
                      })}
                    {(!loading && facturas.length === 0) &&
                      <tr>
                        <td colSpan="8"> CONSULTA SIN RESULTADOS </td>
                      </tr>
                    }
                  </tbody>
                </Table>
                {(loading) && <Spinner loading={loading} />}
              </Row>
            </Container>
          </div>
        }
      </div>
    );
  }
}
export default (Gestiones);


// WEBPACK FOOTER //
// ./src/components/bussines/pedidos/reportepedidos.jsx